{
  "R": [
    255, 248, 242, 235, 229, 222, 212, 202, 193, 183, 173, 145, 117, 78, 39, 0,
    0, 0, 0, 0, 0, 64, 128, 191, 255, 255, 255, 255, 255, 238, 221, 204, 214,
    224, 235, 245, 255, 249, 242, 236, 229, 223, 217, 210, 204, 197, 191, 184,
    176, 169, 161, 154, 146, 139, 132, 124, 117, 109, 102, 0
  ],
  "G": [
    255, 251, 247, 243, 239, 235, 235, 235, 235, 235, 235, 216, 197, 174, 150,
    127, 153, 178, 204, 229, 255, 255, 255, 255, 255, 220, 185, 150, 115, 77,
    38, 0, 31, 61, 92, 122, 153, 138, 122, 107, 92, 77, 61, 46, 31, 15, 0, 0, 0,
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0
  ],
  "B": [
    255, 254, 253, 252, 251, 250, 251, 252, 253, 254, 255, 226, 198, 132, 66, 0,
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 40, 80, 120, 160, 200, 199,
    198, 197, 196, 196, 195, 194, 193, 192, 191, 184, 176, 169, 161, 154, 146,
    139, 132, 124, 117, 109, 102, 0
  ],
  "A": [
    256, 256, 256, 256, 256, 256, 256, 256, 256, 256, 256, 256, 256, 256, 256,
    256, 256, 256, 256, 256, 256, 256, 256, 256, 256, 256, 256, 256, 256, 256,
    256, 256, 256, 256, 256, 256, 256, 256, 256, 256, 256, 256, 256, 256, 256,
    256, 256, 256, 256, 256, 256, 256, 256, 256, 256, 256, 256, 256, 256, 256
  ],
  "I": [
    0, 4, 8, 12, 16, 20, 24, 28, 32, 36, 40, 44, 48, 52, 56, 60, 64, 68, 72, 76,
    80, 84, 88, 92, 96, 100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140,
    144, 148, 152, 156, 160, 164, 168, 172, 176, 180, 184, 188, 192, 196, 200,
    204, 208, 212, 216, 220, 224, 228, 232, 236, 240, 244, 248, 255
  ]
}
